import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eatl-business1',
  templateUrl: './eatl-business1.component.html',
  styleUrls: ['./eatl-business1.component.scss']
})
export class EatlBusiness1Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
